import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../../components/Layout';
import diff from 'object-diff';
import { RowDefinition, ColumnDefinition } from 'griddle-react';
import {
  ButtonToolbar,
  ButtonGroup,
  Button,
  Modal,
} from 'react-bootstrap';

import { fullDate, getCurrentDate, monthNameFormatDate } from '../../../core/date';
import StyledGriddle from '../../../components/StyledGriddle';
import Griddle, { plugins } from 'griddle-react';
import TicketDetailView from './TicketDetailView';
import { Link } from 'react-router';
import { browserHistory } from 'react-router';


const sortProperties = [
  { id: 'state', sortAscending: true },
];

export const styleConfig = {
  icons: {
    TableHeadingCell: {
      sortDescendingIcon: '▼',
      sortAscendingIcon: '▲',
    },
  },
  classNames: {
    Row: 'row-class',
    Table: 'table-striped table',
    NextButton: 'btn btn-sm btn-success',
    PreviousButton: 'btn btn-sm btn-success'
  },
  styles: {
    Filter: { fontSize: 18 },
  },
};

const dateDisplay = ({ value }) => {
  return (
    <span> {monthNameFormatDate(value)} </span>
  )
}

class TicketList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirm: false,
      confirmModalValues: {},
      modalBodyText: '',
      tickets_list: [],
      show: false,
      ticket_id: 0,
      showError: false,
      contact_resp: '',
      showContactError: false
    }
  }

  componentWillMount() {
    
  }

  componentDidMount() {
    //if(this.state.contact_resp == ''){
      this.props.requestContact((resp) =>{
        this.setState({contact_resp:resp.message})
        if(!resp.message){
          this.setState({showContactError: true})
        }
      })
    //}
    
    this.props.requestTickets((response) => {
      let data = []
      if(!response.ticketlist.code){
        response.ticketlist.forEach((ticket) => {
          data.push({
            req_id: ticket.id,
            id: ticket.id,
            subject: ticket.subject,
            created_at: ticket.created_at,
            updated_at: ticket.updated_at,
            status: ticket.status ? ticket.status == 2 ? 'Open' : ticket.status == 3 ? 'Pending' : ticket.status == 4 ? 'Resolved' : ticket.status == 5 ? 'Closed' : 'N/A' : 'N/A',
            priority: ticket.priority ? ticket.priority == 1 ? 'Low' : ticket.priority == 2 ? 'Medium' : ticket.priority == 3 ? 'High' : ticket.priority == 4 ? 'Urgent' : 'N/A' : 'N/A',
          })
        })
        this.setState({ tickets_list: data })
    }else{
      this.setState({showError: true})
    }  
    })
  

  }
  viewConfirm = (e) => {
    const ticket = e.currentTarget.getAttribute('data-item');
      this.setState({show: true,ticket_id:ticket})
  }

  onCloseModal =() =>{
    this.setState({show: false})
  }

  handleCloseErrorModal = ()=>{
    this.setState({showContactError: false})
  }

  gotoNewTicket=()=>{
    if(this.state.contact_resp){
      browserHistory.push(`/createticket`);
    }else{
      this.setState({showContactError: true})
    }
  }

  render() {

    const ViewButtonColumn = ({ value }) => {
      return (
          <ButtonGroup>
            <Button name="Remove" bsSize="small" data-item={value} bsStyle="success" title="View Ticket" onClick={this.viewConfirm}>
            <i className="fa fa-eye" />
            </Button>
          </ButtonGroup>
      )
    };


    const PriorityColumn = ({ value }) => {
      switch (value) {
        case 1:
          return 'Low';
        case 2:
          return 'Medium';
        case 3:
          return 'High';
        case 4:
          return 'Urgent';
        default:
          return 'N/A';
      }
    }
    const StatusColumn = ({ value }) => {
      let status = '';
      switch (value) {
        case 2:
          status = 'Open';
        case 3:
          status = 'Pending';
        case 4:
          status = 'Resolved';
        case 5:
          status = 'Closed';
        default:
          status = 'N/A';
      }
      return status
    }
    if (this.state.showError) {
      return (
        <Layout>
          <div className="planner col-sm-12" id="freshdeskErrorSection">
            <p className="text-center" style={{paddingTop:'15%',fontWeight:'bold',fontSize:'20px'}}>
              {/* <i className="fa fa-spinner fa-spin fa-3x fa-fw" /> */}
              <span>Unable to access Support page. Please contact admin.</span>
            </p>
          </div>
        </Layout>
      );
    }
    return (
      <Layout>
        <div>
          <div className="row tour-head">
            <div className="col-md-12 tour-headText">
              <h2>Support</h2>
            </div>
          </div>
          <hr />
          <div className="row tour-head">
            <div className="col-md-12 tour-headText">
              {/* <Link to="/createticket" > */}
                <Button bsStyle="success" onClick={this.gotoNewTicket}>
                  Add New Ticket
              </Button>
              {/* </Link> */}
            </div>
          </div>
          <div className="row tour-head">
            <div className="col-md-12 tour-headText">
              <h4>My Tickets</h4>
            </div>
          </div>
          <Griddle
            data={this.state.tickets_list}
            styleConfig={styleConfig}
            plugins={[plugins.LocalPlugin]}
            components={{
              SettingsToggle: () => <span />,
            }}
            showFilter={true}
          >
            <RowDefinition>
              {/* <ColumnDefinition id="req_id" title="Request_ID" order={1} /> */}
              <ColumnDefinition id="subject" title="Subject" order={2} />
              <ColumnDefinition id="created_at" title="Created at" order={3} customComponent={dateDisplay} />
              <ColumnDefinition id="updated_at" title="Updated at" order={4} customComponent={dateDisplay} />
              <ColumnDefinition id="status" title="Status" order={5} />
              {/* <ColumnDefinition id="priority" title="Priority" order={6} /> */}
              <ColumnDefinition id="id" title="Action" order={11} customComponent={ViewButtonColumn} />
            </RowDefinition>
          </Griddle>
          {this.state.show && 
            <TicketDetailView 
              {...this.props } 
              ticket_id = {this.state.ticket_id}
              show = {this.state.show}
              onClose = {this.onCloseModal}/>
          }
          {this.state.showContactError && (<Modal show={this.state.showContactError} onHide={this.handleCloseErrorModal}>
                <Modal.Header closeButton>
                <Modal.Title>Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                <p> {'Error occurred.Please email your issue at info@usecatch.com'}</p>

                <ButtonToolbar style={{ float: 'right' }}>
                    <Button bsStyle="success" onClick={this.handleCloseErrorModal}>
                        Ok
                    </Button>
                </ButtonToolbar>
                </Modal.Body>
                <Modal.Footer style={{ clear: 'both' }} />
            </Modal>
            )}

        </div>
      </Layout>
    );
  }
}

export default TicketList;



// WEBPACK FOOTER //
// src/routes/support/components/TicketList.js